import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../_services';
import { MatIconModule} from '@angular/material/icon'; 
import { UserService } from '../../_services';
import { first } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

  
export class HeaderComponent implements OnInit {
	// title: string = "Dashboard";
  // constructor() { }
  title = 'Vertigo Administracion';
  currentUser: any;
  currentRole: any;
  usuario: string;
  nombre_seller: string;
  current_user: any;
  selectedIdioma = localStorage.getItem('idioma'); 
  user_id : any;

  @Output()
	open: EventEmitter<boolean> = new EventEmitter()
  
  ngOnInit() {
     
    this.asignarDatos(); 
  	this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    // console.log("el rol es ");
    // console.log(this.usuario);
    // console.log("fin del rol")
    // console.log(this.authenticationService.currentRole)
    if(this.usuario){
    	this.nombre_seller = this.usuario['seller_name'];
      this.user_id       = this.usuario['id']
      
    }
    // console.log(this.usuario);
  }

   

  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue 
  } 
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }
   
  cambiar_idioma(idioma){
    this.selectedIdioma = idioma;
    let datos_envio = {
      idioma: this.selectedIdioma,  
      user_id: this.user_id 
       
    };

    this.UserService.cambiar_idioma_user(datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          localStorage.setItem('idioma', this.selectedIdioma);
          location.reload()
           
          
        }else{
          this.snackBar.open('error!, No se guardo el idioma', "OK", {                      
            duration: 5000,
          });
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 5000,
        });
    });
  
  }

	constructor(
	    private router: Router,
	    private authenticationService: AuthenticationService,
      private UserService: UserService,
      private snackBar: MatSnackBar,
      public dialog: MatDialog
	) {
	    
	}

	logout() {
		// console.log("vamos con el logout")
	    this.authenticationService.logout();
	    this.router.navigate(['/login']);
	}

	clickMenu() {
    this.open.emit(true);
  }

	// actualizar() {
	// 	// console.log("entramos en Add Item en el app component")
	//    this.authenticationService.currentRole.subscribe(x => this.currentRole = x);
	// }

}
